"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./in-dom");
var vendors = ['', 'webkit', 'moz', 'o', 'ms'], clearTimeout = 'clearTimeout', raf = fallback;
var getKey = function (vendor, k) {
    return vendor + (!vendor ? k : (k[0].toUpperCase() + k.substr(1))) + 'AnimationFrame';
};
if (in_dom_1.inDOM) {
    vendors.some(function (vendor) {
        var rafKey = getKey(vendor, 'request');
        if (rafKey in window) {
            clearTimeout = getKey(vendor, 'cancel');
            raf = function (cb) { return window[rafKey](cb); };
            return true;
        }
        return false;
    });
}
/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
    var curr = new Date().getTime(), ms = Math.max(0, 16 - (curr - prev)), req = setTimeout(fn, ms);
    prev = curr;
    return req;
}
function requestAnimationFrame(cb) {
    return raf(cb);
}
exports.requestAnimationFrame = requestAnimationFrame;
(function (requestAnimationFrame) {
    requestAnimationFrame.cancel = function (id) {
        return window[clearTimeout](id);
    };
})(requestAnimationFrame || (requestAnimationFrame = {}));
exports.requestAnimationFrame = requestAnimationFrame;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/util/request-animation-frame.js
// module id = 534
// module chunks = 0 1 2 3 4 5 6